import { Component } from '@angular/core';

@Component({
  selector: 'app-heading-component',
  templateUrl: './heading.component.html',
  styleUrls: ['./heading.component.scss'],
})
export class HeadingComponent {}



// WEBPACK FOOTER //
// ./src/app/common/components/HeadingComponent/heading.component.ts